/*
 * Back and the signed-in header. A page shown again from history keeps the header it was rendered with: restored
 * from the back/forward cache (Safari keeps pages there after a sign-in), or re-read from the HTTP cache, it still
 * offers "Log in" after the shopper signed in, or the account menu after they signed out.
 * Every page render records whether a customer was signed in (window.customerEmail, printed by layout/theme.liquid
 * before this script runs; only "1" or "0" is stored). A page shown from history whose render differs from the
 * latest one reloads, so the header and everything else tied to the account is current. A normal page view
 * requests nothing.
 */
(function () {
  var KEY = "hb:signed-in";
  var RELOADED = "hb:signed-in-reload";
  var rendered = window.customerEmail ? "1" : "0";

  function latest() {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  // One reload per page and state, so a page that still comes back stale cannot loop.
  function reloadOnce() {
    var mark = location.href + "|" + latest();
    try {
      if (sessionStorage.getItem(RELOADED) === mark) return false;
      sessionStorage.setItem(RELOADED, mark);
    } catch (e) {
      return false;
    }
    location.reload();
    return true;
  }

  function isStale() {
    var value = latest();
    return value !== null && value !== rendered;
  }

  // Back or Forward to a page read from the HTTP cache (nothing transferred): this script runs again with the old
  // render. A page fetched again is already current.
  var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType("navigation")[0] : null;
  var fromHistoryCache = !!(nav && nav.type === "back_forward" && nav.transferSize === 0);
  if (fromHistoryCache && isStale() && reloadOnce()) return;

  // An old render from the HTTP cache is not the latest state, so only a fresh render records it.
  if (!fromHistoryCache) {
    try {
      localStorage.setItem(KEY, rendered);
    } catch (e) {}
  }

  window.addEventListener("pageshow", function (event) {
    if (event.persisted && isStale()) reloadOnce();
  });
})();
